<template>
  <div class="mt-3">
    <div v-for="item in model.areas" :key="item.area.id">
      <answer
        :is-read-only="isReadOnly"
        :value="item"
        @input="onAnswer(item, $event)"
      />
    </div>
  </div>
</template>

<script>
import alertMixin from '@/mixins/alert.mixin.js';

import Answer from './components/AreaAnswer.vue';

export default {
  name: 'LearningStylesRelevantToPerformance',
  components: { Answer },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    onAnswer(item, value) {
      const index = this.model.areas.findIndex(
        (a) => a.area?.id === item.area.id
      );
      if (index !== -1) {
        this.model.areas[index] = value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .whodas-title .dot {
  background-color: white !important;
}
::v-deep .whodas-title .dot .title-icon {
  color: #ff7058 !important;
}
</style>
